import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuNL from "../../components/nl/MenuNL";
import FooterNL from "../../components/nl/FooterNL";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Coel Advocaten Publicaties"}
                    description={"Een lijst met boeken en persartikelen gepubliceerd door leden van het advocatenkantoor Coel Advocaten."}
                    url={"https://www.coeladvocaten.be/nl/publicaties"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/publicaties", language:"nl" },
                        { url:"https://www.coeladvocaten.be/en/publications", language:"en" }
                    ]}
                />

                <MenuNL
                    switchUrlEN="/en/publications"
                />
                
                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-publications"></div>
                        <div className="slider">
                            <h1>Publicaties</h1>
                            <h2>Coel Advocaten</h2>
                            <p></p>
                            <a href="/nl/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="team">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-2"></div>
                                <div className="col-lg-8">
                                    <div className="cell">
                                        <div className="image">
                                            <img src="/static/images/ons-team-frank-thumb.jpg" alt="Frank Coel, administratiefrecht, familierecht, ondernemingsrecht, strafrecht" />
                                        </div>
                                        <h3>Frank Coel</h3>
                                        <ul>
                                            <li>Inleiding tot het Vreemdelingenrecht, Brugge, Die Keure, 2002</li>
                                            <li>Diverse thematische artikels voor gespecialiseerde vakbladen</li>
                                            <li>Sinds 1990 herhaaldelijk spreker en gastdocent voor studiedagen ten verzoeke van de UA, de OVB en de Orde van advocaten te Mechelen</li>
                                            <li>Lid van diverse commissies in de schoot van de Orde van Vlaamse Balies</li>
                                            <li>Lid van de Klachtencommissie voor gesloten Centra</li>
                                            <li>Zetelend lid van de tuchtraad in beroep</li>
                                            <li>Voormalig lid van de Raad van Orde van Advocaten te Mechelen, lid van de taxatiecommissie en penningmeester van de Orde van advocaten te Mechelen</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterNL />
            </Layout>
        );
    }
}

export default Index;
